import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MILLET_START_TOUR_EVENT } from './startTour';
import { getKnownUserType, getUserTypeFromToken } from './tourUserType';

const TourExperience = React.lazy(() => import('./TourExperience'));

function TourProvider({ children, userType }) {
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [tourNonce, setTourNonce] = useState(0);
  const [determinedUserType, setDeterminedUserType] = useState(userType);
  const location = useLocation();

  useEffect(() => {
    setDeterminedUserType(getKnownUserType(userType) || getUserTypeFromToken());
  }, [userType]);

  const finishTour = () => {
    setIsTourOpen(false);
    localStorage.setItem('tourCompleted', 'true');
    localStorage.removeItem('shouldStartTour');
    localStorage.removeItem('currentTourStep');
  };

  useEffect(() => {
    if (determinedUserType !== 'influencer' && determinedUserType !== 'brand') {
      return undefined;
    }
    const shouldStartTour = localStorage.getItem('shouldStartTour');
    const tourCompleted = localStorage.getItem('tourCompleted');
    if (shouldStartTour === 'true' && tourCompleted !== 'true') {
      const timer = setTimeout(() => setIsTourOpen(true), 200);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [determinedUserType, location.pathname]);

  useEffect(() => {
    const onStart = () => {
      setTourNonce((n) => n + 1);
      setIsTourOpen(true);
    };
    window.addEventListener(MILLET_START_TOUR_EVENT, onStart);
    return () => window.removeEventListener(MILLET_START_TOUR_EVENT, onStart);
  }, []);

  return (
    <>
      {children}
      {isTourOpen
        && (determinedUserType === 'influencer' || determinedUserType === 'brand') && (
        <React.Suspense fallback={null}>
          <TourExperience
            userType={determinedUserType}
            tourNonce={tourNonce}
            isOpen={isTourOpen}
            onFinish={finishTour}
          />
        </React.Suspense>
      )}
    </>
  );
}

export default TourProvider;
